/* Quietdown: skrypt motywu Shopify */
(function () {
  var C = window.QUIETDOWN || {}, R = C.routes || {};
  // napisy z plików lokalizacji (dane-js), polskie wartości jako zapas
  var TT = C.t || {};
  function tx(k, zapas) { return TT[k] || zapas; }
  var PL = (C.jezyk || 'pl') === 'pl';
  var doc = document, body = doc.body;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var smooth = function (t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); };
  var easeIO = function (t) { t = clamp(t, 0, 1); return -(Math.cos(Math.PI * t) - 1) / 2; };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function bezOgonkow(s) { return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l'); }
  function rdzen(w) { return w.length > 4 ? w.slice(0, Math.max(3, w.length - 3)) : w; }
  function trasa(nazwa, zapas) { var r = R[nazwa] || zapas; return r.replace(/\/$/, ''); }

  /* ---------- pieniądze: złotówki po polsku (2 290 zł), inne waluty rynku przez Intl ---------- */
  function zl(centy) {
    var c = Math.round(+centy || 0), waluta = C.waluta || 'PLN';
    if (waluta === 'PLN') {
      var calosc = Math.floor(c / 100), gr = c % 100;
      return String(calosc).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (gr ? ',' + (gr < 10 ? '0' : '') + gr : '') + ' zł';
    }
    try { return new Intl.NumberFormat(C.jezyk || 'pl', { style: 'currency', currency: waluta, minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(c / 100); } catch (e) {}
    var f = C.moneyFormat || '{{amount_with_comma_separator}} zł';
    function grupy(n, dz, tys, dec) {
      var s = (n / 100).toFixed(dz).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, tys) + (s[1] ? dec + s[1] : '');
    }
    var out = f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, t) {
      if (t === 'amount') return grupy(c, 2, ',', '.');
      if (t === 'amount_no_decimals') return grupy(c, 0, ',', '.');
      if (t === 'amount_with_comma_separator') return grupy(c, 2, '.', ',');
      if (t === 'amount_no_decimals_with_comma_separator') return grupy(c, 0, '.', ',');
      if (t === 'amount_with_space_separator') return grupy(c, 2, ' ', ',');
      if (t === 'amount_no_decimals_with_space_separator') return grupy(c, 0, ' ', ',');
      if (t === 'amount_with_apostrophe_separator') return grupy(c, 2, "'", '.');
      return grupy(c, 2, '.', ',');
    });
    out = out.replace(/([,.])00(?=\D|$)/, '');
    var t = doc.createElement('div'); t.innerHTML = out; return t.textContent;
  }

  /* ---------- pasek informacji ---------- */
  var pasek = $$('.pasek p');
  if (pasek.length > 1) {
    var pi = 0;
    setInterval(function () {
      if (body.classList.contains('pauza')) return;
      pasek[pi].classList.remove('on'); pi = (pi + 1) % pasek.length; pasek[pi].classList.add('on');
    }, 4500);
  }

  /* ---------- nagłówek ---------- */
  var nag = $('.naglowek'), cien = false;
  function naScroll() { var c = scrollY > 40; if (nag && c !== cien) { cien = c; nag.classList.toggle('cien', c); } }
  addEventListener('scroll', naScroll, { passive: true }); naScroll();

  /* ---------- szuflady, wyszukiwarka, okna ---------- */
  var ostatni = null;
  function otworz(el, fokus) {
    ostatni = doc.activeElement;
    el.classList.add('otwarta'); el.setAttribute('aria-hidden', 'false');
    body.style.overflow = 'hidden';
    setTimeout(function () { var f = fokus ? $(fokus, el) : $('button, a, input', el); if (f) f.focus(); }, 60);
  }
  function zamknij(el) {
    el.classList.remove('otwarta'); el.setAttribute('aria-hidden', 'true');
    body.style.overflow = '';
    if (ostatni && ostatni.focus) ostatni.focus();
  }
  doc.addEventListener('click', function (e) {
    var t = e.target.closest('[data-otworz]');
    if (t) { var el = doc.getElementById(t.getAttribute('data-otworz')); if (el) { e.preventDefault(); otworz(el, t.getAttribute('data-fokus')); } return; }
    var z = e.target.closest('[data-zamknij]');
    if (z) { var w = z.closest('.szuflada, .szukaj, .modal'); if (w) zamknij(w); }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var o = $('.szuflada.otwarta, .szukaj.otwarta, .modal.otwarta'); if (o) zamknij(o);
  });
  $$('.menu-mobilne a').forEach(function (a) { a.addEventListener('click', function () { var m = $('#menu-mobilne'); if (m) zamknij(m); }); });

  /* ---------- koszyk (Shopify AJAX API) ---------- */
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var koszyk = C.cart || { items: [], item_count: 0, total_price: 0 };
  function rysujKoszyk(puk) {
    var lista = $('#koszyk-lista'), dol = $('#koszyk-dol');
    $$('.licznik').forEach(function (l) {
      l.textContent = koszyk.item_count; l.classList.toggle('on', koszyk.item_count > 0);
      if (puk) { l.classList.remove('puk'); void l.offsetWidth; l.classList.add('puk'); }
    });
    $$('[data-koszyk-ile]').forEach(function (b) { b.setAttribute('aria-label', tx('koszykIle', 'Koszyk, produkty: ILE').replace('ILE', koszyk.item_count)); });
    if (!lista) return;
    if (!koszyk.item_count) {
      lista.innerHTML = '<div class="koszyk-pusty"><p>' + esc(tx('pusty', 'Koszyk jest pusty.')) + '</p><a class="btn jasny" href="' + esc(trasa('all', '/collections/all')) + '">' + esc(tx('zobaczProdukty', 'Zobacz produkty')) + '</a></div>';
      if (dol) dol.hidden = true; return;
    }
    if (dol) dol.hidden = false;
    lista.innerHTML = koszyk.items.map(function (it) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : (C.img && C.img[it.handle]) || '';
      var wariant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="wariant">' + esc(it.variant_title) + '</p>' : '';
      return '<div class="poz"><a href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="84" height="105">' : '') + '</a>' +
        '<div><h3>' + esc(it.product_title) + '</h3>' + wariant +
        '<div class="ilosc"><button type="button" data-klucz="' + esc(it.key) + '" data-ile="' + (it.quantity - 1) + '" aria-label="' + esc(tx('mniej', 'Mniej')) + '">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-klucz="' + esc(it.key) + '" data-ile="' + (it.quantity + 1) + '" aria-label="' + esc(tx('wiecej', 'Więcej')) + '">+</button></div>' +
        '<div><button type="button" class="usun" data-klucz="' + esc(it.key) + '" data-ile="0">' + esc(tx('usun', 'Usuń')) + '</button></div></div>' +
        '<p class="cena">' + zl(it.final_line_price) + '</p></div>';
    }).join('');
    var suma = koszyk.total_price, prog = +C.darmowaOd || 0, brak = prog - suma;
    var t = $('#dostawa-tekst'); if (t) t.textContent = brak > 0 ? tx('brakuje', 'Do darmowej dostawy brakuje KWOTA.').replace('KWOTA', zl(brak)) : tx('darmowa', 'Dostawa jest bezpłatna.');
    var tor = $('#dostawa-tor'); if (tor) { tor.parentNode.hidden = !(prog > 0); if (prog > 0) tor.style.setProperty('--p', Math.min(1, suma / prog)); }
    var s = $('#koszyk-suma'); if (s) s.textContent = zl(suma);
  }
  function pobierzKoszyk() { return fetch(trasa('cart', '/cart') + '.js', { headers: JSONH, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) { koszyk = j; rysujKoszyk(); return j; }); }
  function dodaj(id, ilosc) {
    return fetch(trasa('add', '/cart/add') + '.js', { method: 'POST', headers: JSONH, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: +id, quantity: ilosc }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || tx('blad', 'Nie udało się dodać do koszyka.')); return j; }); })
      .then(function () { return pobierzKoszyk(); })
      .then(function () { rysujKoszyk(true); var k = $('#koszyk'); if (k) otworz(k, '.koszyk-dol .btn'); });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-klucz]');
    if (!b) return;
    b.disabled = true;
    fetch(trasa('change', '/cart/change') + '.js', { method: 'POST', headers: JSONH, credentials: 'same-origin', body: JSON.stringify({ id: b.getAttribute('data-klucz'), quantity: Math.max(0, Math.min(99, +b.getAttribute('data-ile'))) }) })
      .then(function (r) { return r.json(); }).then(function (j) { koszyk = j; rysujKoszyk(); })
      .catch(function () { b.disabled = false; });
  });
  doc.addEventListener('visibilitychange', function () { if (!doc.hidden) pobierzKoszyk().catch(function () {}); });
  rysujKoszyk();

  /* ---------- wyszukiwarka (podpowiedzi Shopify) ---------- */
  var pole = $('#szukaj-pole');
  if (pole) {
    var wyn = $('#szukaj-wyniki'), pusto = $('#szukaj-pusto'), licznik = 0, timer = null;
    var szukaj = function () {
      var q = pole.value.trim(), nr = ++licznik;
      if (q.length < 2) { wyn.innerHTML = ''; pusto.hidden = true; return; }
      fetch(trasa('suggest', '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][prefix]=last', { headers: JSONH })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (nr !== licznik) return;
          var lista = (j.resources && j.resources.results && j.resources.results.products) || [];
          wyn.innerHTML = lista.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || (C.img && C.img[p.handle]) || '';
            var cena = p.price_min !== undefined && p.price_max !== undefined && p.price_min !== p.price_max ? 'od ' + zl(Math.round(parseFloat(p.price_min) * 100)) : zl(Math.round(parseFloat(p.price) * 100));
            return '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="70">' : '<span></span>') + '<div><strong>' + esc(p.title) + '</strong><span>' + cena + '</span></div></a>';
          }).join('');
          pusto.hidden = lista.length > 0;
        }).catch(function () {});
    };
    pole.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(szukaj, 160); });
    $$('.szukaj-podpowiedzi button').forEach(function (b) { b.addEventListener('click', function () { pole.value = b.textContent; szukaj(); pole.focus(); }); });
  }

  /* ---------- wejścia przy przewijaniu ---------- */
  var io = new IntersectionObserver(function (wpisy) {
    wpisy.forEach(function (w) {
      if (!w.isIntersecting) return;
      var el = w.target; el.classList.add('in'); io.unobserve(el);
      if (el.classList.contains('stagger')) setTimeout(function () { el.classList.add('gotowe'); }, 1400);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  $$('.wjedz, .stagger, .material-foto, .noce, .kroki').forEach(function (e) { io.observe(e); });

  /* ---------- pauza na ukrytej karcie, wyłączenie animacji ---------- */
  doc.addEventListener('visibilitychange', function () { body.classList.toggle('pauza', doc.hidden); });
  try { if (localStorage.getItem('quietdown-bez-animacji') === '1') body.classList.add('bez-animacji'); } catch (e) {}
  $$('.bez-anim-link').forEach(function (b) {
    var ustaw = function () { b.textContent = body.classList.contains('bez-animacji') ? tx('wlacz', 'Włącz animacje') : tx('wylacz', 'Wyłącz animacje'); };
    ustaw();
    b.addEventListener('click', function () {
      body.classList.toggle('bez-animacji');
      try { localStorage.setItem('quietdown-bez-animacji', body.classList.contains('bez-animacji') ? '1' : '0'); } catch (e) {}
      ustaw();
    });
  });

  /* ---------- hero: kołdra opada ---------- */
  function rng(seed) { var s = seed >>> 0; return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }; }
  $$('.dziel').forEach(function (h, n) {
    var tekst = h.textContent.trim(), slowa = tekst.split(/\s+/), r = rng(17 + n);
    h.innerHTML = '<span class="sr">' + esc(tekst) + '</span><span aria-hidden="true">' + slowa.map(function (w, i) {
      var th = (i / Math.max(1, slowa.length - 1)) * 0.42 + r() * 0.05;
      return '<span class="w" style="--th:' + th.toFixed(3) + '">' + esc(w) + '</span>';
    }).join(' ') + '</span>';
  });
  var hero = $('.hero'), scena = $('.hero-scena'), kadr = $('.hero-kadr');
  var koldra = $('.w-koldra'), koniec = $('.w-koniec'), wsk = $('.hero-wskazowka');
  if (hero && koldra) {
    var pasma = $$('.pasmo').map(function (el) { return { el: el, a: +el.dataset.a, b: +el.dataset.b, ramp: el.dataset.ramp ? +el.dataset.ramp : 0, op: -1, k: -1, akt: null }; });
    var IW = 1920, IH = 1072, CX = 0.641, CY = 0.364, DX = 0.085, DY = 0.355;
    var geo = { rw: 0, rh: 0 }, ost = { tr: '', kop: -1, eop: -1, ks: '', wsk: null };
    var mierz = function () {
      var w = koldra.clientWidth, h = koldra.clientHeight;
      var s = Math.max(w / IW, h / IH), rw = IW * s, rh = IH * s;
      var pos = getComputedStyle(koldra).objectPosition.split(' ').map(function (v) { return parseFloat(v) / 100; });
      var ox = (w - rw) * (isNaN(pos[0]) ? 0.5 : pos[0]), oy = (h - rh) * (isNaN(pos[1]) ? 0.5 : pos[1]);
      geo = { rw: rw, rh: rh };
      koldra.style.transformOrigin = (ox + CX * rw).toFixed(1) + 'px ' + (oy + CY * rh).toFixed(1) + 'px';
      ost.tr = '';
    };
    var postep = function () {
      var top = hero.getBoundingClientRect().top, zakres = hero.offsetHeight - scena.offsetHeight;
      var st = parseFloat(getComputedStyle(scena).top) || 0;
      return clamp((st - top) / Math.max(1, zakres), 0, 1);
    };
    var loadK = 0, loadStart = 0;
    var rysuj = function (p) {
      var t = easeIO((p - 0.04) / 0.66);
      var tr = 'translate3d(' + (t * DX * geo.rw).toFixed(1) + 'px,' + (t * DY * geo.rh).toFixed(1) + 'px,0) scale(' + (1 + 0.1 * t).toFixed(4) + ',' + (1 - 0.3 * t).toFixed(4) + ')';
      if (tr !== ost.tr) { koldra.style.transform = tr; ost.tr = tr; }
      var kop = +(1 - smooth((p - 0.56) / 0.24)).toFixed(3); if (kop !== ost.kop) { koldra.style.opacity = kop; ost.kop = kop; }
      var eop = +smooth((p - 0.5) / 0.28).toFixed(3); if (eop !== ost.eop) { koniec.style.opacity = eop; ost.eop = eop; }
      var ks = 'scale(' + (1.06 - 0.06 * p).toFixed(4) + ')'; if (ks !== ost.ks) { kadr.style.transform = ks; ost.ks = ks; }
      var w = p > 0.03; if (wsk && w !== ost.wsk) { wsk.classList.toggle('ukryta', w); ost.wsk = w; }
      pasma.forEach(function (b, i) {
        var f = Math.min(0.05, (b.b - b.a) / 3);
        var wej = i === 0 ? 1 : smooth((p - b.a) / f), wyj = i === pasma.length - 1 ? 1 : 1 - smooth((p - (b.b - f)) / f);
        var op = +(wej * wyj).toFixed(3), ramp = b.ramp || Math.min(0.06, (b.b - b.a) * 0.35);
        var k = clamp((p - b.a) / ramp, 0, 1); if (i === 0) k = Math.max(k, loadK); k = Math.round(k * 125) / 125;
        if (op !== b.op) { b.el.style.opacity = op; b.op = op; }
        if (Math.abs(k - b.k) >= 0.008 || (k !== b.k && (k === 0 || k === 1))) { b.el.style.setProperty('--k', k); b.k = k; }
        var akt = op > 0.5; if (akt !== b.akt) { b.el.classList.toggle('aktywne', akt); b.el.setAttribute('aria-hidden', akt ? 'false' : 'true'); b.akt = akt; }
      });
    };
    var cel = 0, pokaz = 0, raf = null, last = 0, naEkranie = true;
    var tick = function (now) {
      var dt = Math.min(100, now - (last || now)); last = now;
      if (loadK < 1) { if (!loadStart) loadStart = now; loadK = easeIO((now - loadStart) / 1300); }
      pokaz += (cel - pokaz) * (1 - Math.pow(1 - 0.14, dt / 16.667));
      if (Math.abs(cel - pokaz) < 0.0004 && loadK >= 1) { pokaz = cel; raf = null; last = 0; } else raf = requestAnimationFrame(tick);
      rysuj(pokaz);
    };
    var start = function () { if (raf === null) raf = requestAnimationFrame(tick); };
    var onScroll = function () { cel = postep(); if (naEkranie) start(); };
    new IntersectionObserver(function (e) { naEkranie = e[0].isIntersecting; if (naEkranie) onScroll(); }).observe(hero);
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', function () { mierz(); onScroll(); rysuj(pokaz); });
    var gotowe = function () { mierz(); cel = pokaz = postep(); rysuj(pokaz); start(); };
    if (koldra.complete) gotowe(); else koldra.addEventListener('load', gotowe, { once: true });
    mierz(); cel = pokaz = postep(); rysuj(pokaz); start();
  }

  /* ---------- dobór kołdry ---------- */
  var suwak = $('#temp');
  if (suwak) {
    var out = $('#temp-out'), przekroj = $('.przekroj'), modele = {};
    $$('.dobor-model').forEach(function (m) { modele[m.dataset.model] = m.dataset; });
    var obecny = '', obecnyRoz = '', rozm = $('#dobor-rozmiar'), warianty = {};
    var policz = function () {
      var t = +suwak.value, f = +(($('input[name=czucie]:checked') || { value: 0 }).value);
      out.textContent = t + '°C'; suwak.setAttribute('aria-valuetext', (suwak.getAttribute('data-stopni') || 'N stopni').replace('N', t));
      suwak.style.setProperty('--p', ((t - suwak.min) / (suwak.max - suwak.min) * 100) + '%');
      var wynik = (20 - t) + f * 2.4, klucz = wynik >= 3 ? 'zimowa' : wynik <= -1.5 ? 'letnia' : 'caloroczna';
      var r = rozm ? rozm.value : '';
      if ((klucz === obecny && r === obecnyRoz) || !modele[klucz]) return;
      var nowyModel = klucz !== obecny, pierwszy = !obecny;
      obecny = klucz; obecnyRoz = r; var m = modele[klucz];
      if (!warianty[klucz]) { try { warianty[klucz] = JSON.parse(m.warianty || '{}'); } catch (e) { warianty[klucz] = {}; } }
      // wynik prowadzi prosto do karty kołdry w wybranym rozmiarze (?variant=)
      var w = r ? warianty[klucz][r] : null;
      przekroj.style.setProperty('--loft', m.loft);
      var el = [$('#w-nazwa'), $('#w-opis'), $('#w-gramy'), $('#w-cena'), $('#w-komora')];
      var pokaz = function () {
        el[0].textContent = m.nazwa; el[1].textContent = m.opis; el[4].textContent = m.komora;
        el[2].textContent = w ? (w.gramy ? w.gramy + ' g' : '·') : (r ? '·' : m.gramy || '·');
        el[3].textContent = w ? w.cena : (r ? '·' : m.cena || '·');
        if (r) $$('.w-roz').forEach(function (x) { x.textContent = r; });
        $('#w-link').href = w ? w.url : m.url;
        el.forEach(function (e) { e.classList.remove('zmiana'); });
      };
      if (nowyModel && !pierwszy) { el.forEach(function (e) { e.classList.add('zmiana'); }); setTimeout(pokaz, 220); } else pokaz();
    };
    suwak.addEventListener('input', policz);
    if (rozm) rozm.addEventListener('change', policz);
    $$('input[name=czucie]').forEach(function (r) { r.addEventListener('change', policz); });
    policz();
  }

  /* ---------- 30 nocy: kropki, paralaksa ---------- */
  $$('.noce').forEach(function (n) { var ile = +n.dataset.ile || 30, h = ''; for (var i = 0; i < ile; i++) h += '<i style="--i:' + i + '"></i>'; n.innerHTML = h; });
  var par = $$('[data-paralaksa]');
  if (par.length) {
    var pRaf = null;
    var pRysuj = function () {
      pRaf = null;
      par.forEach(function (img) {
        var box = img.parentNode.getBoundingClientRect(), vh = innerHeight;
        if (box.bottom < 0 || box.top > vh || innerWidth <= 720) return;
        var q = clamp((vh - box.top) / (vh + box.height), 0, 1);
        img.style.transform = 'translate3d(0,' + (-q * (img.offsetHeight - box.height)).toFixed(1) + 'px,0)';
      });
    };
    addEventListener('scroll', function () { if (!pRaf) pRaf = requestAnimationFrame(pRysuj); }, { passive: true });
    pRysuj();
  }

  /* ---------- język i kraj (waluta rynku): zmiana od razu po wyborze ---------- */
  $$('[data-lokalizacja]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  /* ---------- kolekcja: sortowanie ---------- */
  var sort = $('[data-sortuj]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });

  /* ---------- termin dostawy ---------- */
  function terminDostawy(teraz) {
    var d = new Date(teraz), wysylka = new Date(d), godz = +C.godzina || 14;
    var robocz = function (x) { var w = x.getDay(); return w !== 0 && w !== 6; };
    var dzis = robocz(d) && d.getHours() < godz;
    if (!dzis) { do { wysylka.setDate(wysylka.getDate() + 1); } while (!robocz(wysylka)); }
    var dost = new Date(wysylka); do { dost.setDate(dost.getDate() + 1); } while (!robocz(dost));
    var jutro = new Date(d); jutro.setDate(jutro.getDate() + 1);
    var loc = PL ? 'pl-PL' : C.jezyk;
    var dzien = wysylka.toLocaleDateString(loc, { weekday: 'long' }).replace('środa', 'środę');
    var kiedy = dzis ? tx('dzis', 'dziś') : (wysylka.toDateString() === jutro.toDateString() ? tx('jutro', 'jutro') : tx('wDzien', 'w DZIEN').replace('DZIEN', dzien));
    return { dzis: dzis, godz: godz, kiedy: kiedy, dostawa: dost.toLocaleDateString(loc, { weekday: 'long', day: 'numeric', month: 'long' }) };
  }

  /* ---------- strona produktu ---------- */
  var pj = $('#produkt-json');
  if (pj) {
    var P = JSON.parse(pj.textContent), form = $('#form-produkt'), wariantPole = $('#p-wariant');
    var OMN = {}; try { OMN = JSON.parse($('#omnibus-json').textContent); } catch (e) {}
    var ilosc = 1, foto = 0;
    var wariant = P.variants.filter(function (v) { return String(v.id) === wariantPole.value; })[0] || P.variants[0];
    var mini = $$('#miniatury button'), img = $('#foto'), box = $('#foto-glowne');
    var pokazFoto = function (i) {
      if (!mini.length) return;
      foto = (i + mini.length) % mini.length;
      box.classList.remove('zoom');
      var b = mini[foto], src = b.getAttribute('data-duze');
      img.style.opacity = 0;
      var n = new Image(); n.src = src;
      var podmien = function () { img.removeAttribute('srcset'); img.src = src; img.alt = b.getAttribute('data-alt') || ''; img.style.opacity = 1; };
      if (n.complete) podmien(); else { n.onload = podmien; n.onerror = podmien; }
      mini.forEach(function (x, j) { x.setAttribute('aria-current', j === foto ? 'true' : 'false'); });
    };
    mini.forEach(function (b, i) { b.addEventListener('click', function () { pokazFoto(i); }); });
    var pop = $('#foto-pop'), nast = $('#foto-nast');
    if (mini.length < 2 && pop) pop.parentNode.hidden = true;
    if (pop) pop.addEventListener('click', function (e) { e.stopPropagation(); pokazFoto(foto - 1); });
    if (nast) nast.addEventListener('click', function (e) { e.stopPropagation(); pokazFoto(foto + 1); });
    var origin = function (e) { var r = box.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%'; };
    if (box && img) {
      box.addEventListener('click', function (e) { if (e.target.closest('.foto-strzalki')) return; if (box.classList.toggle('zoom')) origin(e); });
      box.addEventListener('mousemove', function (e) { if (box.classList.contains('zoom')) origin(e); });
      box.addEventListener('mouseleave', function () { box.classList.remove('zoom'); });
      var tx0 = null;
      box.addEventListener('touchstart', function (e) { tx0 = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) { if (tx0 === null) return; var dx = e.changedTouches[0].clientX - tx0; tx0 = null; if (Math.abs(dx) > 45) pokazFoto(foto + (dx < 0 ? 1 : -1)); });
    }
    var przyciski = $$('#p-rozmiary button'), param = $('#p-param');
    var odswiez = function () {
      var cena = wariant.price, przed = wariant.compare_at_price;
      $('#p-cena').textContent = zl(cena * ilosc);
      var low = OMN[wariant.id], promo = przed > cena && low && cena < low;
      var s = $('#p-przed'); if (s) { s.hidden = !promo; if (promo) s.textContent = zl(przed * ilosc); }
      var om = $('#p-omnibus'); if (om) { om.hidden = !promo; if (promo) $('#p-omnibus-cena').textContent = zl(low); }
      var noc = $('#p-noc'); if (noc) { var lata = +noc.getAttribute('data-lata'), gr = Math.round(cena / (lata * 365)); noc.textContent = tx('noc', 'Około KWOTA za noc przy LATA latach używania.').replace('KWOTA', gr < 100 && PL && (C.waluta || 'PLN') === 'PLN' ? gr + ' gr' : zl(gr)).replace('LATA', lata); }
      var raty = $('#p-raty'); if (raty) { var nr = +raty.getAttribute('data-raty'); raty.textContent = tx('raty', 'Możesz też zapłacić w RATY ratach po KWOTA z Klarna.').replace('RATY', nr).replace('KWOTA', zl(Math.ceil(cena / nr))); }
      $('#p-osz').textContent = ilosc > 1 ? zl(cena) + ' ' + tx('zaSztuke', 'za sztukę') : '';
      przyciski.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-wartosc') === wariant.option1 ? 'true' : 'false'); });
      if (param) {
        var akt = przyciski.filter(function (b) { return b.getAttribute('data-wartosc') === wariant.option1; })[0];
        var g = akt && akt.getAttribute('data-gramy'), k = param.getAttribute('data-komora'), h = [];
        if (g) h.push('<span>Puch: <b>' + esc(g) + ' g</b></span>');
        if (k) h.push('<span>Komora: <b>' + esc(k) + '</b></span>');
        param.innerHTML = h.join(''); param.hidden = !h.length;
      }
      var aktb = przyciski.filter(function (b) { return b.getAttribute('data-wartosc') === wariant.option1; })[0];
      if (aktb) {
        var ppr = $('#pp-rozmiar'), ppg = $('#pp-gramy'), ppw = $('#pp-waga'), gg = aktb.getAttribute('data-gramy'), ww = +aktb.getAttribute('data-waga');
        if (ppr) ppr.textContent = wariant.option1;
        if (ppg && gg) ppg.textContent = gg + ' g';
        if (ppw && ww) ppw.textContent = tx('kg', 'około KG kg').replace('KG', PL ? String(Math.round(ww / 100) / 10).replace('.', ',') : String(Math.round(ww / 100) / 10));
      }
      $$('#p-wymiary tr[data-wartosc]').forEach(function (tr) { tr.classList.toggle('akt', tr.getAttribute('data-wartosc') === wariant.option1); });
      var dod = $('#p-dodaj'); dod.disabled = !wariant.available; dod.textContent = wariant.available ? tx('dodaj', 'Dodaj do koszyka') : tx('niedostepny', 'Chwilowo niedostępny');
      var pk = $('#pk-wariant'); if (pk) pk.textContent = (P.variants.length > 1 ? wariant.option1 + ' · ' : '') + zl(cena);
      wariantPole.value = wariant.id;
    };
    przyciski.forEach(function (b) {
      b.addEventListener('click', function () {
        var w = P.variants.filter(function (v) { return v.option1 === b.getAttribute('data-wartosc'); })[0];
        if (!w) return; wariant = w; odswiez();
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', w.id); history.replaceState(null, '', u.toString()); }
        if (w.featured_media && mini.length) { var i = P.media ? P.media.map(function (m) { return m.id; }).indexOf(w.featured_media.id) : -1; if (i > -1) pokazFoto(i); }
      });
    });
    $('#p-minus').addEventListener('click', function () { ilosc = Math.max(1, ilosc - 1); $('#p-ilosc').value = ilosc; odswiez(); });
    $('#p-plus').addEventListener('click', function () { ilosc = Math.min(9, ilosc + 1); $('#p-ilosc').value = ilosc; odswiez(); });
    var blad = $('#p-blad');
    var wyslij = function (e) {
      if (e) e.preventDefault();
      var dod = $('#p-dodaj'); dod.disabled = true; blad.hidden = true;
      dodaj(wariant.id, ilosc).catch(function (err) { blad.textContent = err.message; blad.hidden = false; }).then(function () { dod.disabled = !wariant.available; });
    };
    form.addEventListener('submit', wyslij);
    var pkd = $('#pk-dodaj'); if (pkd) pkd.addEventListener('click', wyslij);
    var t = terminDostawy(Date.now()), tt = $('#p-termin');
    if (tt) tt.innerHTML = esc(t.dzis ? tx('wyslemyDzis', 'Zamów do GODZ:00, a wyślemy dziś.').replace('GODZ', t.godz) : tx('wyslemy', 'Wyślemy KIEDY.').replace('KIEDY', t.kiedy)) + ' ' + esc(tx('dostawa', 'Dostawa:')) + ' <b>' + esc(t.dostawa) + '</b>.';
    var bar = $('#przyklejony');
    if (bar) new IntersectionObserver(function (e) {
      var on = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); if (pkd) pkd.tabIndex = on ? 0 : -1;
    }).observe($('#p-dodaj'));
    odswiez();
  }

  /* ---------- pomoc: szukanie w pytaniach, aktywny dział ---------- */
  var faqPole = $('#faq-pole');
  if (faqPole) {
    var brak = $('#faq-brak');
    var pyt = $$('#faq details').map(function (d) { var s = $('summary', d); return { d: d, s: s, oryg: s.firstChild.textContent, t: bezOgonkow(d.textContent) }; });
    faqPole.addEventListener('input', function () {
      var slowa = bezOgonkow(faqPole.value.trim()).split(/\s+/).filter(Boolean).map(rdzen), ile = 0;
      pyt.forEach(function (x) {
        var ok = slowa.every(function (w) { return x.t.indexOf(w) > -1; });
        x.d.hidden = !ok; if (ok) ile++;
        x.d.open = ok && slowa.length > 0 && ile <= 2;
        var tekst = esc(x.oryg);
        if (slowa.length) { var norm = bezOgonkow(x.oryg); slowa.forEach(function (w) { var i = norm.indexOf(w); if (i > -1) tekst = esc(x.oryg.slice(0, i)) + '<mark>' + esc(x.oryg.slice(i, i + w.length)) + '</mark>' + esc(x.oryg.slice(i + w.length)); }); }
        x.s.firstChild.remove(); x.s.insertAdjacentHTML('afterbegin', '<span>' + tekst + '</span>');
      });
      brak.classList.toggle('on', ile === 0);
    });
  }
  var linki = $$('.pomoc-nav a');
  if (linki.length) {
    var io2 = new IntersectionObserver(function (wpisy) { wpisy.forEach(function (w) { if (w.isIntersecting) linki.forEach(function (a) { a.classList.toggle('akt', a.getAttribute('href') === '#' + w.target.id); }); }); }, { rootMargin: '-30% 0px -60% 0px' });
    linki.forEach(function (a) { var s = doc.getElementById(a.getAttribute('href').slice(1)); if (s) io2.observe(s); });
  }
})();
